import { Stack } from "@altimateai/lego";
import { Checkbox, Label, Typography } from "@altimateai/lego";
import { finalLineageDownload, finalTableLineageDownload } from "../api";
import { ExportFinalLineageArgs, ExportFinalTableLineageArgs } from "../types";
import { useState } from "react";
import { useMutation } from "../../api/index";
import { useLineageDispatch } from "../context/LineageProvider";
import { setModalArgs } from "../context/LineageSlice";
import ExportLineageModalBase, { ColumnExportParams, ExportParams } from "./ExportLineageModalBase";

export const ExportFinalLineageModal = ({ modalArgs }: { modalArgs: ExportFinalLineageArgs }) => {
  const { table, column } = modalArgs;
  const lineageDispatch = useLineageDispatch();
  const [params, setParams] = useState<ColumnExportParams>({
    upstream: true,
    downstream: false,
    direct: true,
    indirect: false,
  });
  const {
    mutate,
    loading: isExporting,
    error,
  } = useMutation({
    queryFn: () => finalLineageDownload({ column_rk: `${table}/${column}`, ...params }),
    onSuccess: () => lineageDispatch(setModalArgs({ type: "none" })),
  });
  const handleExport = () => {
    if (isExporting) return;
    if (!params.upstream && !params.downstream) return;
    if (!params.direct && !params.indirect) return;
    mutate();
  };

  return (
    <ExportLineageModalBase
      title={`${table}/${column}`}
      params={params}
      setParams={setParams}
      onExport={handleExport}
      isExporting={isExporting}
      error={error}
      validationErrors={[
        {
          condition: !params.direct && !params.indirect,
          message: "Select at least one of the direct or non direct",
        },
      ]}
    >
      <Stack direction="column" gap="xxs">
        <Typography weight="medium" size="sm" className="al-mb-0">
          Lineage Type
        </Typography>
        <Stack>
          <Checkbox
            id="direct"
            checked={params.direct}
            onCheckedChange={v => setParams(prev => ({ ...prev, direct: v as boolean }))}
          />
          <Label htmlFor="direct">Select</Label>
        </Stack>
        <Stack>
          <Checkbox
            id="indirect"
            checked={params.indirect}
            onCheckedChange={v => setParams(prev => ({ ...prev, indirect: v as boolean }))}
          />
          <Label htmlFor="indirect">Non select</Label>
        </Stack>
      </Stack>
    </ExportLineageModalBase>
  );
};

export const ExportFinalTableLineageModal = ({
  modalArgs,
}: {
  modalArgs: ExportFinalTableLineageArgs;
}) => {
  const { table } = modalArgs;
  const lineageDispatch = useLineageDispatch();
  const [params, setParams] = useState<ExportParams>({
    upstream: true,
    downstream: false,
  });
  const {
    mutate,
    loading: isExporting,
    error,
  } = useMutation({
    queryFn: () =>
      finalTableLineageDownload({
        table_rk: table,
        upstream: params.upstream,
        downstream: params.downstream,
      }),
    onSuccess: () => lineageDispatch(setModalArgs({ type: "none" })),
  });
  const handleExport = () => {
    if (isExporting) return;
    if (!params.upstream && !params.downstream) return;
    mutate();
  };

  return (
    <ExportLineageModalBase
      title={table}
      params={params}
      setParams={setParams}
      onExport={handleExport}
      isExporting={isExporting}
      error={error}
    />
  );
};
